import React, { ReactNode } from "react";

const ModalBody: React.FC<{ children: ReactNode }> = ({ children }) => (
	<div className="modal-body">{children}</div>
);

export default ModalBody;
